import Grade from './grade';

export default class Zone {
    public zoneId: string;
    public zoneName: string;
    public gradeList: Grade[];
    constructor({
        zoneId = '',
        zoneName = '',
        gradeList = [],
    }={}) {
        this.zoneId =zoneId ;
        this.zoneName =zoneName ;
        this.gradeList = gradeList||[];
    }
}